<template>
<flickity ref="flickityInstance" id="vjs-sliders-content" class="vjs-sliders-content" :options="flickityOptions">
    <div
      v-for="(slide, index) in slides"
      :key="index"
      class="carousel__Images vjs-sliders-field"
        :id="'vjs-sliders-field-' + index"
      :class="{ active: checkSlides(index) }"
    >
      <div class="timecode">{{ getDurationString(slide.timecode) }}</div>
      <img class="vjs-sliders-field-thumb" :src="slide.src" :alt="'slide-' + index"
 />
    </div>
  </flickity>
</template>

<script>
import Flickity from 'vue-flickity';
import { secondsToDuration } from "@/components/utils/helpers";
import {updateOverlayButtonsPosition} from "@/components/utils/richmedia";
export default {
  components: {
    Flickity,
  },
  props: ["slides", "player"],
  data() {
    return {
      currentSlide: -1,
      flickityOptions: {
      adaptiveHeight: true,
      setGallerySize: false,
      groupCells: true,
      imagesLoaded: true,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        contain: true,
        cellAlign: "left",
        on:{
            staticClick: this.handleSlideClick,
        }
      },
    };
  },
  methods: {
  
    getDurationString(s) {
      return secondsToDuration(s);
    },
handleSlideClick(event, pointer, cellElement, cellIndex) {
  this.currentSlide = cellIndex;
  const targetTimecode = this.slides[cellIndex].timecode;
  if (Math.round(this.player.currentTime()) !== targetTimecode) {
    this.player.currentTime(targetTimecode);
  }
}
,

    checkSlides(index) {
      return index === this.currentSlide;
    },
  },
  watch: {
    player: {
      handler() {
        this.player.on("timeupdate", () => {
          this.slides?.forEach((slide, index) => {
            if (slide.timecode <= this.player.currentTime()) {
              this.currentSlide = index;
              updateOverlayButtonsPosition();
            }
          });
        });
      },
      deep: true,
    },
  },
};
</script>

<style>
.video-js.vjs-slides.vjs-playing:not(.vjs-user-active) #vjs-sliders-content{
  bottom: 0.5em;

}
#vjs-sliders-content {
  height: 17%;
  bottom: 4.2em;
  position: absolute;
  font-size: 11px;
  transition: bottom 0.5s ease;
  border:1px solid hsla(0, 0%, 100%, .2);
  left: 2%;
  right: 2%; 
  padding:.4em 5em .8em ;
  opacity:0;
}
.video-js.vjs-has-started #vjs-sliders-content {
  opacity:1;
  pointer-events: auto;
  
  
}
.carousel__Images {
background-color: transparent;
    padding: 0;
    border: none;
    overflow: hidden;
    margin: .4em .5% 0;
    top: 0;
    height: calc(100% - .4em);
    width:auto;
    aspect-ratio: 16 / 9;
    border-radius: 0.25em;


}
.carousel__Images.active{
    margin: 0.4em .5% 0;
    transform: none;
    border-width: 3px!important;
    border-style: solid;
    border-color: var(--vm-color-two-08);
    top: -0.4em;
}

.flickity-viewport{
  height:100% !important
}
#vjs-sliders-content .carousel__Images.active .timecode{
  background: var(--vm-color-two-08);
}
#vjs-sliders-content .timecode {
    bottom: 1em;
    margin-left: 0;
    position: absolute;
    padding: 4px 10px;
    background: rgba(0, 0, 0, .4);
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    font-weight: 600;
    font-size: 8pt;
    color: #fff;
    left:0
}
.flickity-viewport,
.flickity-slider {
  height: 100% !important;
}

#vjs-sliders-content .carousel__slide {
  padding: 0 10px;
}

#vjs-sliders-content .carousel_Images.active {
  opacity: 1 !important;
}

#vjs-sliders-content .carousel_Images .active .timecode {
  background: var(--vm-color-two-06) !important;
}

#vjs-sliders-content .carousel_Images .active img {
  border: 3px solid var(--vm-color-two-06);
}
.vjs-sliders-field-thumb{
  width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
